import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LanguageRoutingService } from '../services/language-routing.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const languageRoutingService = inject(LanguageRoutingService);
  
  if (authService.isLoggedIn()) {
    return true;
  }
  
  // Navigate to login page with language prefix
  const currentLang = languageRoutingService.getCurrentLanguage();
  router.navigate([`/${currentLang}/login`], { 
    queryParams: { redirect: state.url } 
  });
  
  return false;
};
